module.exports = __webpack_public_path__ + "img/avatar.0def682f.jpg";